import * as Sentry from '@sentry/browser'
import { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { useRouteError } from 'react-router'

import ErrorPage from '@/components/ErrorPage'
import { HelpFab } from '@/components/help-fab'
import useAuth from '@/hooks/useAuth'
import { reloadOnceForStaleChunk } from '@/utils/chunk-reload'

function Error() {
  const error = useRouteError() as Error
  const {
    merchantsSelected,
    merchantSelected,
  } = useAuth()
  const names = merchantsSelected?.map((merchant) => merchant.name).join(', ') || '';

  useEffect(() => {
    // A stale chunk after a deploy is expected, not a bug: recover instead of
    // reporting. Anything else still goes to Sentry.
    if (reloadOnceForStaleChunk(error)) return

    Sentry.captureException(error, {
      tags: {
        merchants: names,
        merchant: merchantSelected?.name,
        message: error.message,
      }
    })
  }, [error, names, merchantSelected?.name])

  return (
    <>
      <Helmet title="Error" />
      <ErrorPage error={error.message} />

      <HelpFab />
    </>
  )
}

export { Error }
